import React from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { useLastLocation } from "react-router-last-location";
import HomePage from "../pages/home/HomePage";
import ErrorsPage from "../pages/errors/ErrorsPage";
import SsoAuth from "../pages/auth/SsoAuth";
import { LayoutContextProvider } from "../../_metronic";
import Layout from "../../_metronic/layout/Layout";
import * as routerHelpers from "../router/RouterHelpers";

const EMPRESA_URL = process.env.REACT_APP_FRONTEND_CASHBARBER_URL || "https://painel.cashbarber.com.br";

export const Routes = withRouter(({ history }) => {
  const lastLocation = useLastLocation();
  routerHelpers.saveLastLocation(lastLocation);
  const { isAuthorized, menuConfig, userLastLocation } = useSelector(
    ({ auth, urls, builder: { menuConfig } }) => ({
      menuConfig,
      isAuthorized: auth.me != null,
      userLastLocation: routerHelpers.getLastLocation(),
    }),
    shallowEqual
  );

  if (!isAuthorized && !window.location.pathname.startsWith("/auth/sso")) {
    window.location.href = EMPRESA_URL;
    return null;
  }

  return (
    <LayoutContextProvider history={history} menuConfig={menuConfig}>
      <Switch>
        <Route path="/auth/sso" component={SsoAuth} />
        <Route path="/error" component={ErrorsPage} />

        {isAuthorized && (
          <Layout>
            <HomePage userLastLocation={userLastLocation} />
          </Layout>
        )}
      </Switch>
    </LayoutContextProvider>
  );
});
